import React, {useEffect} from 'react'
import ReactExport from "react-export-excel";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const ExportToExcel = (props:any) => {
    useEffect(() => {
        console.info('enter')
    },[])

    return ( 
        <ExcelFile filename="StatusHistory" hideElement={true}>
        <ExcelSheet data={props.excelResponse.length? props.excelResponse : null } name="StatusHistory">
            <ExcelColumn label="Health" value="health" />
            <ExcelColumn label="Timestamp" value="timestamp" />
            <ExcelColumn label="Response Code" value="responseCode" />
            <ExcelColumn label="Configured" value={(col: any) => col.configured ? "Yes" : "NA"} />
            <ExcelColumn label="Error Message" value={(col: any) => col.dependency.length ? col.dependency?.join(',') : ''} />
        </ExcelSheet>
    </ExcelFile>
    )                                                                                                                                                                                                                                                                                                                                           
}

export default ExportToExcel